import enumKeys from 'helper/enum-keys';
import i18n from 'helper/i18n';
import { FavoriteClusterIDMapType, FavoriteClusterIDType } from 'types/Favorites';

export const FALLBACK_URL = i18n(`react.impulsCoach.routes.favorites.href`);

export const FavoritesClusterIDs: FavoriteClusterIDMapType = {
	ALL: 'ALL',
	RECIPE: 'RECIPE',
	WORKOUT: 'WORKOUT',
	TIP: 'TIP',
	EXERCISE: 'EXERCISE',
	RECOMMENDATION: 'RECOMMENDATION',
};

export const FavoriteClusterIDKeys: string[] = enumKeys(FavoritesClusterIDs) as any;

export const favoriteClusterTranslatedRoutes: { [key: string]: FavoriteClusterIDType } = {
	[i18n(`react.impulsCoach.routes.favorites.href`)]: FavoritesClusterIDs.ALL,
	[i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.RECIPE.toLowerCase()}.href`
	)]: FavoritesClusterIDs.RECIPE,
	[i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.WORKOUT.toLowerCase()}.href`
	)]: FavoritesClusterIDs.WORKOUT,
	[i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.TIP.toLowerCase()}.href`
	)]: FavoritesClusterIDs.TIP,
	[i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.EXERCISE.toLowerCase()}.href`
	)]: FavoritesClusterIDs.EXERCISE,
	[i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.RECOMMENDATION.toLowerCase()}.href`
	)]: FavoritesClusterIDs.RECOMMENDATION,
};

export const favoriteClusterRoutes: { [key: string]: string } = {
	[FavoritesClusterIDs.ALL]: i18n(`react.impulsCoach.routes.favorites.href`),
	[FavoritesClusterIDs.RECIPE]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.RECIPE.toLowerCase()}.href`
	),
	[FavoritesClusterIDs.WORKOUT]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.WORKOUT.toLowerCase()}.href`
	),
	[FavoritesClusterIDs.TIP]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.TIP.toLowerCase()}.href`
	),
	[FavoritesClusterIDs.EXERCISE]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.EXERCISE.toLowerCase()}.href`
	),
	[FavoritesClusterIDs.RECOMMENDATION]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.RECOMMENDATION.toLowerCase()}.href`
	),
};

export const favoriteClusterTranslatedTitles: { [key: string]: string } = {
	[FavoritesClusterIDs.ALL]: i18n(`react.impulsCoach.routes.favorites.title`),
	[FavoritesClusterIDs.RECIPE]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.RECIPE.toLowerCase()}.title`
	),
	[FavoritesClusterIDs.WORKOUT]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.WORKOUT.toLowerCase()}.title`
	),
	[FavoritesClusterIDs.TIP]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.TIP.toLowerCase()}.title`
	),
	[FavoritesClusterIDs.EXERCISE]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.EXERCISE.toLowerCase()}.title`
	),
	[FavoritesClusterIDs.RECOMMENDATION]: i18n(
		`react.impulsCoach.routes.favorites.cluster.${FavoritesClusterIDs.RECOMMENDATION.toLowerCase()}.title`
	),
};

export type FavoriteClusterRessource = {
	id: any;
	title: string;
};

export const isValidCluster = (cluster: string = ''): boolean => {
	const possibleTranslatedClusterRoutes = Object.keys(favoriteClusterTranslatedRoutes);
	const isValid = !!~possibleTranslatedClusterRoutes.indexOf(cluster);

	if (!isValid && cluster !== '') {
		// TODO: Handle proper issue
		// warn(`Selected cluster ${cluster} is not valid`);
	}

	return isValid;
};

export const getRessourcesForCluster = (cluster: string = ''): FavoriteClusterRessource => {
	if (!isValidCluster(cluster)) {
		cluster = '';
	}

	const clusterID = favoriteClusterTranslatedRoutes[cluster];

	return {
		id: clusterID,
		title: favoriteClusterTranslatedTitles[clusterID],
	};
};
